import { useQuery } from "@tanstack/react-query";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import ArticleCard from "@/components/ArticleCard";

export default function Articles() {
  const [params] = useSearchParams();
  const tag = params.get("tag");

  const { data: articles = [], isLoading } = useQuery({
    queryKey: ["articles", tag],
    queryFn: () => api.get("/articles", { params: tag ? { tag } : {} }).then((r) => r.data),
  });
  const { data: tags = [] } = useQuery({
    queryKey: ["tags"],
    queryFn: () => api.get("/tags").then((r) => r.data),
  });

  return (
    <div className="mx-auto max-w-6xl px-5 sm:px-8 pt-12">
      <header className="max-w-2xl">
        <span className="text-xs font-semibold uppercase tracking-widest text-brand-clay">Journal</span>
        <h1 className="mt-3 font-heading text-4xl sm:text-5xl text-brand-ink tracking-tight">
          Reviewed Ayurveda articles
        </h1>
        <p className="mt-4 text-brand-muted">
          Reference-backed, medically reviewed writing on doshas, therapies, herbs and seasonal wellness.
        </p>
      </header>

      <div className="mt-8 flex flex-wrap gap-2">
        <Link
          to="/articles"
          data-testid="tag-filter-all"
          className={`rounded-full border px-4 py-1.5 text-sm transition-colors ${
            !tag ? "border-brand bg-brand text-brand-sand" : "border-brand-line bg-white text-brand-muted hover:border-brand"
          }`}
        >
          All
        </Link>
        {tags.map((t) => (
          <Link
            key={t.slug}
            to={`/articles?tag=${t.slug}`}
            data-testid={`tag-filter-${t.slug}`}
            className={`rounded-full border px-4 py-1.5 text-sm transition-colors ${
              tag === t.slug ? "border-brand bg-brand text-brand-sand" : "border-brand-line bg-white text-brand-muted hover:border-brand"
            }`}
          >
            {t.name}
          </Link>
        ))}
      </div>

      {isLoading ? (
        <p className="mt-16 text-center text-brand-muted">Loading…</p>
      ) : (
        <div className="mt-10 grid gap-7 sm:grid-cols-2 lg:grid-cols-3">
          {articles.map((a, i) => (
            <ArticleCard key={a.slug} article={a} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
